import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api, SnsTaskStatus } from 'api';
const snsMarketingApi = api.requireLogicalApi('snsMarketingApiImpl');
const initialState = {
    loadingCurrent: false,
    currentTask: {
        taskId: '',
        taskName: '',
        accounts: [],
    },
    currentTaskStatus: SnsTaskStatus.DRAFT,
    currentPosts: {
        loading: false,
        hasError: false,
        posts: [],
    },
    deletedPostDbIds: [],
};
export const getSnsTaskBaseInfoSync = createAsyncThunk('sns-marketing/getBaseInfo', async () => {
    return snsMarketingApi.createSnsTask();
});
export const getSnsTaskPlanSync = createAsyncThunk('sns-marketing/getTaskPlan', async (accounts) => {
    return snsMarketingApi.getDefaultPlan({ accounts });
});
export const getSnsTaskDetailSync = createAsyncThunk('sns-marketing/getSnsTaskDetail', async (id) => {
    return snsMarketingApi.getSnsTaskDetail(id);
});
const SnsMarketingTaskSlice = createSlice({
    name: 'SnsMarketingTaskReducer',
    initialState,
    reducers: {
        resetCurrent(state) {
            state.loadingCurrent = false;
            state.currentTask = {
                taskId: '',
                taskName: '',
                accounts: [],
            };
            state.currentTaskStatus = SnsTaskStatus.DRAFT;
            state.currentPosts = {
                loading: false,
                hasError: false,
                posts: [],
            };
            state.deletedPostDbIds = [];
        },
        addDeletedPost(state, action) {
            state.deletedPostDbIds = [...state.deletedPostDbIds, action.payload.postDbId];
        },
        removeDeletedPost(state, action) {
            state.deletedPostDbIds = state.deletedPostDbIds.filter(item => item !== action.payload.postDbId);
        },
        setTaskName(state, action) {
            state.currentTask.taskName = action.payload;
        },
        setAccounts(state, action) {
            state.currentTask.accounts = action.payload;
        },
        setAiParam(state, action) {
            state.currentTask.aiGeneratePostParam = Object.assign(Object.assign(Object.assign({ companyName: '', companyProfile: '', goods: [], industry: '', language: '', tone: '', companyUrls: [], companyVideoUrls: [] }, state.currentTask.aiGeneratePostParam), action.payload), { wordsUpperLimit: action.payload.wordsUpperLimit === 0 ? undefined : action.payload.wordsUpperLimit });
        },
        setCurrentPosts(state, action) {
            state.currentPosts = Object.assign(Object.assign({}, state.currentPosts), action.payload);
        },
        setTaskStatus(state, action) {
            state.currentTaskStatus = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getSnsTaskBaseInfoSync.pending, state => {
            state.loadingCurrent = true;
        })
            .addCase(getSnsTaskBaseInfoSync.fulfilled, (state, action) => {
            state.currentTask.taskId = action.payload.taskId;
            state.currentTask.taskName = action.payload.taskName;
            state.loadingCurrent = false;
        });
        builder.addCase(getSnsTaskPlanSync.fulfilled, (state, { payload }) => {
            state.currentTask.plan = payload;
        });
        builder
            .addCase(getSnsTaskDetailSync.pending, state => {
            state.loadingCurrent = true;
        })
            .addCase(getSnsTaskDetailSync.fulfilled, (state, action) => {
            state.currentTask = Object.assign(Object.assign({}, action.payload), { plan: action.payload.taskExecPlan });
            state.currentTaskStatus = action.payload.status;
            state.loadingCurrent = false;
        });
    },
});
export const actions = SnsMarketingTaskSlice.actions;
export default SnsMarketingTaskSlice.reducer;
